export const SectionHeader = ({ eyebrow, title, subtitle, align = "center", testId }) => {
  const alignCls = align === "left" ? "text-left items-start" : "text-center items-center";
  return (
    <div className={`flex flex-col ${alignCls} max-w-2xl ${align === "center" ? "mx-auto" : ""} mb-12 reveal`} data-testid={testId}>
      {eyebrow && (
        <span className="text-[11px] tracking-[0.28em] uppercase text-brand-gold font-semibold mb-3">
          {eyebrow}
        </span>
      )}
      <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-brand-brown leading-tight">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-4 text-base text-brand-muted leading-relaxed">{subtitle}</p>
      )}
      {align === "center" && (
        <div className="divider-gold mt-6 w-full max-w-xs">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.39 7.36H22l-6.18 4.49L18.21 22 12 17.27 5.79 22l2.39-8.15L2 9.36h7.61z" /></svg>
        </div>
      )}
    </div>
  );
};
